import { useState, useCallback } from 'react';

const getInitialFormState = () => ({
    submitted: false,
    errorNotificationDate: new Date(),
    userName: '',
    dealerName: '',
    selectedDealer: null,
    selectedDealerAddress: null,
    technicalResponsibleUserId: null,
    chassisNo: '',
    vehicleWarrantyInf: null,
    vehicleModelEmissions: '',
    modelYear: '',
    vehicleEmissions: null,
    vehicleGsr: null,
    kmInformation: null,
    menzilType: 1,
    vehicleCustomerInf: '',
    errorDescription: '',
    checksPerformed: '',
    errorEffect: null,
    mainCategory: '',
    mainCategoryName: '',
    secondCategory: '',
    secondCategoryName: '',
    subCategory: '',
    subCategoryName: '',
    subPartCategory: '',
    subPartCategoryName: '',
    failureMode: null,
    failureModeName: '',
    isVor: false,
    moreChassis: false,
    additionalChassis: [],
    cluster: '',
    evcu: '',
    zr5: '',
    problemSolved: false,
    solutionMethod: '',
    solutionDate: null,
    solutionDateFromStatus: false,
    statusBeforeSolved: null,
    onSiteSupport: false,
    onSiteSupportReason: [],
    technicalServiceDeclaration: [],
    technicalPolicy: false,
    visitDate: null,
    visitErrorDesc: '',
    rootCause: '',
    solution: '',
    manHour: null,
    outsourcingExpense: null,
    totalExpenses: null,
    expenseCurr: null,
    ptsCriteria: false,
    ptsNumber: '',
    statusNotification: null,
    statusDate: null,
    statusChanged: false,
    actionManager: null,
    actionManagerChanged: false,
    appointmentTechnResponsible: '',
    totalSolutionTime: '',
    seeCommunicationMovements: '',
    chatHistory: [],
    newMessage: '',
    policyDialogVisible: false,
    hasScrolledToBottom: false,
    warrantyPolicyDialogVisible: false,
    hasScrolledToBottomWarranty: false,
    initialChassisNo: '',
    additionalChassisHasOutOfWarranty: false,
    mainChassisPolicy: 0,
    additionalChassisWarrantyPolicyAccepted: false,
    warrantyPolicyDialogContext: null
});

export const useFormState = () => {
    const [form, setForm] = useState(() => getInitialFormState());

    const setField = useCallback((key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    }, []);

    const setFields = useCallback((patch) => {
        setForm((prev) => ({ ...prev, ...patch }));
    }, []);

    const resetForm = useCallback(() => {
        setForm(getInitialFormState());
    }, []);

    return {
        form,
        setForm,
        setField,
        setFields,
        resetForm
    };
};
